import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        acquea | Admin by
        <a href="https://www.justbit.it" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">justbit</a>
    </div>`
})
export class AppFooter {}
